export class FindingCountEntry {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "evidenceType",
            "baseName": "evidenceType",
            "type": "string",
            "format": ""
        },
        {
            "name": "evidenceDisplayName",
            "baseName": "evidenceDisplayName",
            "type": "string",
            "format": ""
        },
        {
            "name": "count",
            "baseName": "count",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return FindingCountEntry.attributeTypeMap;
    }
    constructor() {
    }
}
